document.addEventListener('DOMContentLoaded', function () {

    function cartAdd(id, quantity = 1) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: id,
                quantity: 1
            },
            dataType: 'json',

            success: function (cart) {
                updateCartDrawerSafe();

            },

            error: function (xhr) {
                console.error(xhr.responseText);
            }
        });

    }

    function changeProductToCart(productId, quantity = 1, lineItemKey) {
        const updates = {
            [lineItemKey]: 0,
            [productId]: quantity
        };

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
        })
            .then(response => response.json())
            .then(cart => {
                console.log('update success', cart);
                updateCartDrawerSafe()
            })
            .catch(error => console.error('更新失败:', error));
    }


    function updateSwipers() {
        if (document.querySelector('.swiper-recommended')) {
            new Swiper(".swiper-recommended", {
                slidesPerView: "auto",
                spaceBetween: 15,
            });
        }
        if (document.querySelector('.swiper-partner')) {
            new Swiper(".swiper-partner", {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 5000, // 自动播放延迟时间（单位为毫秒）
                    disableOnInteraction: false, // 允许用户交互时保持自动播放
                },
            });
        }
    }

    async function updateCartDrawerSafe() {
        try {

            const sectionsUrl =
                `${window.Shopify.routes.root}?sections=cart-drawer`;

            const res = await fetch(sectionsUrl, {
                headers: {
                    'Accept': 'application/json'
                }
            });

            const data = await res.json();

            // ✅ 更新 cart drawer
            if (data['cart-drawer']) {

                const parser = new DOMParser();
                const doc = parser.parseFromString(
                    data['cart-drawer'],
                    'text/html'
                );

                const newDrawer = doc.querySelector('#CartDrawer');
                const currentDrawer = document.querySelector('#CartDrawer');

                if (newDrawer && currentDrawer) {
                    currentDrawer.replaceWith(newDrawer);
                }
                updateSwipers()

            }

            // ✅ reset
            const changeCart = document.getElementById("change-cart");

            if (changeCart) {
                changeCart.innerHTML = "";
                changeCart.closest('.cart_variant_dialog').classList.remove('active');
                changeCart.removeAttribute("data-id");
            }



        } catch (e) {

            console.error(e);

        } finally {


        }
    }

    

   
  

    function getVariantData(handle, id, elements = 'all') {

        const changeCart = document.getElementById("change-cart");
        console.log('vairant modify');

        fetch(`/products/${handle}?section_id=ajax-product`)
            .then(res => {

                // ✅ 如果 429
                if (res.status === 429) {
                    console.warn("429 detected, reloading page...");

                    // 防止连续刷新
                    if (!sessionStorage.getItem("cart429Reloaded")) {
                        sessionStorage.setItem("cart429Reloaded", "1");

                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                    }

                    throw new Error("429 Too Many Requests");
                }

                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }

                return res.text();
            })

            .then(html => {
                // all:更新所有变体，如果是数组，按类名更新
                const htmlDoc = new DOMParser().parseFromString(html, 'text/html')
                if (elements == 'all') {
                    changeCart.innerHTML = html;
                    changeCart.dataset.id = id;
                    changeCart.dataset.handle = handle;
                    changeCart.closest('.cart_variant_dialog').classList.add("active");

                    // 下拉框
                    const select = changeCart.querySelector('#productSelect-ajax-product');
                    // 表单input框
                    const productid = changeCart.querySelector('.cart-change-pop-forms_id');
                    
                    if (!select) return;

                    // 获取变体
                    const swatch_element = changeCart.querySelectorAll('.cart-swatch-element')

                    // 当前的变体id
                    let select_id = id
                    // 变体数量小于2时用第一个变体id
                    if (swatch_element.length < 2) {
                        select_id = swatch_element[0]?.dataset.id
                    }
                    let targetOption = select.querySelector(`option[value="${select_id}"]`);
                    if (!targetOption) {
                        if (select.firstElementChild) {
                            targetOption = select.firstElementChild;
                            select.value = targetOption.value
                            select_id = targetOption.value
                        } else {
                            return
                        }
                    } else {
                        select.value = select_id;
                    }

                    if (productid) productid.value = select_id
                    const pricetext = targetOption.dataset.price;
                    const priceEl = changeCart.querySelector('.cart-change-pop-price');
                    if (priceEl && pricetext != null) {
                        priceEl.innerHTML = pricetext;
                    }

                    const btntext = targetOption.dataset.btn;
                    const btnbox = changeCart.querySelector('.cart-change-pop-forms_button');

                    if (btnbox && btntext) {

                        const addBtn = btnbox.querySelector('.cart-change-pop-cart-btn');
                        const soldBtn = btnbox.querySelector('.cart-change-pop-sold_out');

                        addBtn && addBtn.classList.toggle('hide', btntext !== "add");
                        soldBtn && soldBtn.classList.toggle('hide', btntext !== "sold");
                    }

                    const optionValues = [
                        targetOption.dataset.option1,
                        targetOption.dataset.option2,
                        targetOption.dataset.option3
                    ];

                    optionValues.forEach((value, index) => {

                        if (!value) return;

                        const swatchGroup = changeCart.querySelector(
                            `.custom-swatch[data-option-index="${index}"]`
                        );

                        if (!swatchGroup) return;

                        const swatch = swatchGroup.querySelector(
                            `.swatch-element[data-value="${value}"]`
                        );

                        if (!swatch) return;

                        swatch.classList.add("active");
                        $(swatch).siblings().removeClass("active");

                        const input = swatch.querySelector("input[type='radio']");
                        if (input) input.checked = true;

                    });
                    // ================= 多变体可用性判断 =================
                    const popOption = changeCart.querySelector('.product-variant-content');

                    if (popOption && popOption.classList.contains('cart-multi-variant')) {

                        const selectVariants = changeCart.querySelector('.cart-Select-variants');
                        if (!selectVariants) return;

                        const swatchGroups = changeCart.querySelectorAll('.cart-custom-swatch');

                        // ✅ 使用 option1 / option2 精准匹配（不要用 text）
                        const options = Array.from(selectVariants.options);

                        swatchGroups.forEach(group => {

                            const groupIndex = parseInt(group.dataset.optionIndex);
                            const swatches = group.querySelectorAll('.swatch-element');

                            swatches.forEach(swatch => {

                                const testValues = [];

                                // ✅ 收集所有组选中的值
                                swatchGroups.forEach(g => {
                                    const idx = parseInt(g.dataset.optionIndex);
                                    const active = g.querySelector('.swatch-element.active');
                                    testValues[idx] = active ? active.dataset.value : null;
                                });

                                // ✅ 替换当前测试值
                                testValues[groupIndex] = swatch.dataset.value;

                                // ✅ 严格匹配
                                const match = options.find(option => {

                                    if (option.disabled) return false;

                                    return testValues.every((val, i) => {
                                        return option.dataset["option" + (i + 1)] === val;
                                    });

                                });

                                if (match) {
                                    swatch.classList.remove("unavailable");
                                    swatch.classList.add("available");
                                } else {
                                    swatch.classList.remove("available");
                                    swatch.classList.add("unavailable");
                                }

                            });

                        });
                    }
                } else {
                    // 如果点击的是版本变体就不用更新该选项，把其他伪变体加到后面
                    if (elements == 'VERSION') {
                        const customVariant = changeCart.querySelector('.custom-variant-content')
                        htmlDoc.querySelectorAll('.custom_product_variant').forEach(item => {
                            if (!item.classList.contains('variant-version')) {
                                customVariant.appendChild(item)
                            }
                        })
                    }

                    // 更新头部产品信息,产品变体,按钮
                    const eleList = ['.cart-change-pop-header', '.product-variant-content']
                    eleList.forEach(item => {
                        const oldHtml = changeCart.querySelector(item)
                        const newHtml = htmlDoc.querySelector(item)
                        if (oldHtml && newHtml) {
                            oldHtml.replaceWith(newHtml)
                        }
                    })
                    const select = changeCart.querySelector('#productSelect-ajax-product')
                    const btntext = select.querySelector(`option[value="${select.value}"]`).dataset.btn;
                    const btnbox = changeCart.querySelector('.cart-change-pop-forms_button');

                    if (btnbox && btntext) {

                        const addBtn = btnbox.querySelector('.cart-change-pop-cart-btn');
                        const soldBtn = btnbox.querySelector('.cart-change-pop-sold_out');

                        addBtn && addBtn.classList.toggle('hide', btntext !== "add");
                        soldBtn && soldBtn.classList.toggle('hide', btntext !== "sold");
                    }

                }

            })

            .catch(err => {
                console.error("Fetch error:", err);
            });
    }
    $('body')
        .on("click", ".variant_change", function () {
            const handle = this.dataset.handle;
            const id = this.dataset.id;
            getVariantData(handle, id)
        })

        .on("click", ".cart-change-pop .custom-swatch .swatch-element label", function () {

            const container = document.getElementById("change-cart");
            const select = container.querySelector("#productSelect-ajax-product");

            const currentSwatch = $(this).closest(".swatch-element");
            currentSwatch
                .addClass("active")
                .siblings()
                .removeClass("active");

            const swatchGroups = container.querySelectorAll(".custom-swatch");
            const options = Array.from(select.options);

            // ====================================================
            // 检查 swatch 的可用状态
            // ====================================================

            swatchGroups.forEach(group => {

                const groupIndex = parseInt(group.dataset.optionIndex);
                const swatches = group.querySelectorAll(".swatch-element");

                swatches.forEach(swatch => {
                    const testValues = [];
                    swatchGroups.forEach(g => {
                        const idx = parseInt(g.dataset.optionIndex);
                        const active = g.querySelector(".swatch-element.active");
                        testValues[idx] = active ? active.dataset.value : null;
                    });
                    testValues[groupIndex] = swatch.dataset.value;

                    const match = options.find(option => {
                        return testValues.every((val, i) => {
                            return option.dataset["option" + (i + 1)] === val;
                        });

                    });
                    if (match) {
                        swatch.classList.remove("unavailable");
                        swatch.classList.add("available");
                    } else {
                        swatch.classList.remove("available");
                        swatch.classList.add("unavailable");
                    }
                });

            });
            
            // 匹配值        

            const selectedOptions = [];

            swatchGroups.forEach(group => {
                const index = group.dataset.optionIndex;
                const active = group.querySelector(".swatch-element.active");
                if (active) {
                    selectedOptions[index] = active.dataset.value;
                }
            });

            const matchedOption = options.find(option => {
                return selectedOptions.every((val, index) => {
                    return option.dataset["option" + (parseInt(index) + 1)] === val;
                });
            });

            if (matchedOption) {
                select.value = matchedOption.value;
                const productid = container.querySelector(".cart-change-pop-forms_id");
                if (productid) productid.value = matchedOption.value;
            }

            
            // 自动修正 unavailable 的 active

            swatchGroups.forEach(group => {
                const active = group.querySelector(".swatch-element.active");
                if (active && active.classList.contains("unavailable")) {
                    const firstAvailable = group.querySelector(".swatch-element.available");
                    if (firstAvailable) {
                        firstAvailable.querySelector("label").click();
                    }
                }
            });
        })

        .on("click", ".cart_variant_dialog .dialog_close", function () {
            const changeCart = document.getElementById("change-cart");
            changeCart.closest('.cart_variant_dialog').classList.remove('active');
            changeCart.innerHTML = "";
            changeCart.removeAttribute("data-id");
        })
        .on("click", ".cart-change-pop-btn", function () {
            // 新的id
            const parenbox = $(this).parents("#change-cart");
            const formId = parenbox.find(".cart-change-pop-forms_id").val();

            // 获取 #change-cart 的 data-id
            const changeCartId = parenbox.attr("data-id");
            const popbtnbox = document.querySelector(".cart-change-pop-forms_button");
            // 比较
            if (formId == changeCartId) {
                cartAdd(changeCartId, 1);
                popbtnbox.classList.add('activebtnbox');
            } else {
                // 计算新变体的个数，如果购物车已存在，那么需要加上
                const newVariantInCart = parseInt($(`.cart-items .cart-item[data-id="${formId}"]`).find('.quantity__input').val()) || 0
                const currentVariantInCart = parseInt($(`.cart-items .cart-item[data-id="${changeCartId}"]`).find('.quantity__input').val())
                changeProductToCart(formId, currentVariantInCart + newVariantInCart, changeCartId);
                console.log("ID 不相同" + formId + "---" + changeCartId);
                popbtnbox.classList.add('activebtnbox');
            }

        })
        // 伪变体的点击事件
        .on('click', '.custom_product_variant_list li', function () {
            $(this).addClass('active').siblings().removeClass('active')
            const vairantType = $(this).parents('.custom_product_variant')
            const handle = $(this).data('handle') || ''
            if (vairantType.hasClass('variant-version') && handle) {
                getVariantData(handle, '', 'VERSION')
                vairantType.siblings('.custom_product_variant').remove()
            } else {
                getVariantData(handle, '', 'OTHER')
            }
        })

})

